import AxiosConfig from '@/config/axios-config'

export const LiveAPI = {

  listar (pagina, filtro, empresaCriadoraId) {
    return AxiosConfig.secureJalekoAPI().get('/admin/lives',
      {
        params: {
          page: pagina,
          live: filtro.live,
          url_video: filtro.url_video,
          professor: filtro.professor,
          criado_em_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
          criado_em_fim: filtro.createdDate ? filtro.createdDateRange.endDate : '',
          empresa_criadora_id: empresaCriadoraId
        }
      }).then(response => response.data)
  },

  editar (live) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/lives/${live.id}`, live).then(response => response.data)
  },

  deletar (live) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/lives/${live.id}`, live).then(response => response.data)
  },

  salvar (live, empresaCriadoraId) {
    return AxiosConfig.secureJalekoAPI().post('/admin/lives', live,
      {
        params: {
          empresa_criadora_id: empresaCriadoraId
        }
      }).then(response => response.data)
  }

}

export default LiveAPI
